import request from "@/utils/request";
let investorApi  = {
  /*资方选择*/
  investorList(data, errorback) {
    return request._get("/shop/investor.investor/list", data, errorback);
  },
   /*资方新增*/
   investorAdd(data, errorback) {
    return request._get("/shop/investor.investor/add", data, errorback);
  },
   /*资方shuju*/
   investorIndex(data, errorback) {
    return request._get("/shop/investor.investor/index", data, errorback);
  },

};

export default investorApi;



// WEBPACK FOOTER //
// ./src/api/investor.js